export const arrayDataToText = (data: any) => {
  let text = '';
  if (data?.length > 0) {
    text = data?.map((item: any) => item.text)?.join('\n');
  }
  return text;
};
